import { Component, inject, OnInit, signal } from '@angular/core';
import { ContainerComponent } from '../../components/container/container.component';
import { HeaderComponent } from '../../components/header/header.component';
import { GalleryComponent } from '../../components/gallery/gallery.component';
import { Item } from '../../components/gallery/gallery.models';
import { IntroDialogComponent } from '../../components/intro-dialog/intro-dialog.component';
import { Meta, Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { selectWebshop } from '../../store/webshop/webshop.selectors';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ContainerComponent,
    HeaderComponent,
    GalleryComponent,
    IntroDialogComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  images = signal<Item[] | undefined>(undefined);
  show = signal(false);

  private titleService = inject(Title);
  private metaService = inject(Meta);
  private store = inject(Store);

  ngOnInit() {
    this.images.set([
      {
        itemImageSrc: 'home/index1.jpg',
        alt: 'Description for Image 1',
        title: 'Title 1'
      },
      {
        itemImageSrc: 'home/index3.jpg',
        alt: 'Description for Image 1',
        title: 'Title 1'
      },
      {
        itemImageSrc: 'home/index4.jpg',
        alt: 'Description for Image 1',
        title: 'Title 1'
      }
    ]);

    this.store.select(selectWebshop).pipe(
      filter(webshop => !!webshop),
      take(1)
    ).subscribe(webshop => {
      if (webshop) {
        this.titleService.setTitle(webshop.name);
      }
    });
  }

  changeHeaderOnScroll($event: Event) {

  }
}
